import { winningScents } from './hyalustar-quiz-score.js';

class HyalustarFragranceQuiz extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.data = JSON.parse(this.querySelector('[data-quiz-data]').textContent);
    this.english = document.documentElement.lang.startsWith('en');
    this.answers = Array(this.data.questions.length).fill(null);
    this.step = 0;
    this.dialog = this.querySelector('dialog');
    this.page = this.closest('.hp-profumi');
    this.heading = this.querySelector('#hq-question');
    this.options = this.querySelector('[data-quiz-options]');
    this.results = this.querySelector('[data-quiz-results]');
    this.next = this.querySelector('[data-quiz-next]');
    this.back = this.querySelector('[data-quiz-back]');
    this.restart = this.querySelector('[data-quiz-restart]');
    this.page.querySelectorAll('[data-quiz-open]').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => {
        this.render();
        this.dialog.showModal();
        this.heading.focus();
      });
    });
    this.querySelector('[data-quiz-close]').addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('click', event => {
      if (event.target === this.dialog) {
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }
    });
    this.options.addEventListener('change', event => {
      if (event.target.matches('input[type="radio"]')) {
        this.answers[this.step] = event.target.value;
        this.next.disabled = false;
      }
    });
    this.next.addEventListener('click', () => {
      if (!this.answers[this.step]) return;
      this.step += 1;
      this.render();
      this.heading.focus();
    });
    this.back.addEventListener('click', () => {
      if (this.step > 0) this.step -= 1;
      this.render();
      this.heading.focus();
    });
    this.restart.addEventListener('click', () => {
      this.answers.fill(null);
      this.step = 0;
      this.render();
      this.heading.focus();
    });
    this.results.addEventListener('click', event => {
      if (event.target.closest('a')) this.dialog.close();
    });
  }

  render() {
    const finished = this.step === this.data.questions.length;
    this.dialog.classList.toggle('hq-dialog--result', finished);
    this.options.hidden = finished;
    this.results.hidden = !finished;
    this.next.hidden = finished;
    this.restart.hidden = !finished;
    this.back.disabled = this.step === 0;
    this.querySelector('[data-quiz-counter]').textContent = finished ? (this.english ? 'Your result' : 'Il tuo risultato') : `${this.step + 1} / ${this.data.questions.length}`;
    this.querySelector('progress').value = finished ? this.data.questions.length : this.step;
    if (finished) {
      this.renderResults();
      return;
    }
    const question = this.data.questions[this.step];
    this.heading.textContent = question.title;
    this.next.disabled = !this.answers[this.step];
    this.next.firstChild.textContent = this.step === this.data.questions.length - 1 ? (this.english ? 'See your result ' : 'Scopri il risultato ') : (this.english ? 'Continue ' : 'Continua ');
    const fieldset = document.createElement('fieldset');
    fieldset.className = 'hq-options';
    const legend = document.createElement('legend');
    legend.className = 'visually-hidden';
    legend.textContent = question.title;
    fieldset.append(legend);
    this.data.scents.forEach((scent, index) => {
      const label = document.createElement('label');
      label.className = 'hq-option';
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = `hq-answer-${this.step}`;
      input.value = scent;
      input.checked = this.answers[this.step] === scent;
      const img = document.createElement('img');
      img.src = this.data.images[this.step][index];
      img.alt = question.alts[index];
      img.width = 600;
      img.height = 800;
      const mark = document.createElement('span');
      mark.className = 'hq-selected';
      mark.setAttribute('aria-hidden', 'true');
      mark.textContent = '\u2713';
      label.append(input, img, mark);
      fieldset.append(label);
    });
    this.options.replaceChildren(fieldset);
  }

  renderResults() {
    const winners = winningScents(this.answers, this.data.scents);
    this.heading.textContent = winners.length === 1 ? (this.english ? 'Your fragrance is ' : 'La tua fragranza \u00e8 ') + this.scentName(winners[0].id) : (this.english ? 'Your fragrance matches' : 'Le tue fragranze affini');
    const intro = document.createElement('p');
    intro.textContent = winners.length === 1 ? (this.english ? 'Your choices reflect this fragrance world.' : 'Le tue scelte raccontano questo mondo olfattivo.') : (this.english ? 'These fragrances received the same number of preferences in your answers.' : 'Queste fragranze hanno raccolto lo stesso numero di preferenze nelle tue risposte.');
    const grid = document.createElement('div');
    grid.className = 'hq-results';
    winners.forEach(({ id, score }) => {
      const scent = this.page.querySelector(`#profumo-${id}`);
      const card = document.createElement('article');
      card.className = 'hq-result';
      card.style.setProperty('--scent', scent.style.getPropertyValue('--scent'));
      const image = scent.querySelector('figure img').cloneNode();
      image.loading = 'eager';
      const name = document.createElement('h3');
      name.textContent = this.scentName(id);
      const count = document.createElement('p');
      count.className = 'hq-match';
      count.textContent = this.english ? `${score} matching ${score === 1 ? 'choice' : 'choices'} out of ${this.data.questions.length}` : `${score} ${score === 1 ? 'scelta affine' : 'scelte affini'} su ${this.data.questions.length}`;
      const line = document.createElement('p');
      line.textContent = scent.querySelector('.hp-scent__line').textContent;
      const link = document.createElement('a');
      link.href = `#profumo-${id}`;
      link.textContent = (this.english ? 'Explore ' : 'Esplora ') + name.textContent;
      const copy = document.createElement('div');
      copy.className = 'hq-result__copy';
      copy.append(name, count, line, link);
      card.append(image, copy);
      grid.append(card);
    });
    this.results.replaceChildren(intro, grid);
  }

  scentName(id) {
    return this.page.querySelector(`#hp-title-${id}`).textContent;
  }
}

if (!customElements.get('hyalustar-fragrance-quiz')) {
  customElements.define('hyalustar-fragrance-quiz', HyalustarFragranceQuiz);
}
